"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OwnershipFilter = void 0;
/**
 * Enumeration of possible values for the ownership filter fields in the back-end API. Allows the user to specify
 * which values he wants to fetch when fetching many entities at once.
 *
 * *Swagger Schema Reference :* `OwnershipFilterValue`
 */
var OwnershipFilter;
(function (OwnershipFilter) {
    /**
     * Only fetch the user's own resources.
     */
    OwnershipFilter["OWN_RESOURCES"] = "own_resources";
    /**
     * Fetch all resources belonging to the user's organization.
     */
    OwnershipFilter["ORGANIZATION_RESOURCES"] = "organization_resources";
    /**
     * Fetch *all* resources that match the query.
     */
    OwnershipFilter["ALL_RESOURCES"] = "all_resources";
})(OwnershipFilter = exports.OwnershipFilter || (exports.OwnershipFilter = {}));
//# sourceMappingURL=ownershipFilter.js.map